import { mapActions } from 'vuex';
import { SNACKS_DEFAULT_MILLIS } from '../constants';

export default {
  data: () => ({
    snackbar: {
      message: '',
      color: '',
      duration: SNACKS_DEFAULT_MILLIS,
      visible: false,
    }
  }),
  methods: {
    ...mapActions('snackbars', {
      addSnack: 'add',
      removeSnack: 'remove',
      clearSnacks: 'clear',
    }),
  },
};
